import type { TopupRequestStatus } from "@/modules/wallet/domain/types";

export const TOPUP_STATUS_LABELS: Record<TopupRequestStatus, string> = {
  PENDING: "ລໍຖ້າ",
  APPROVED: "ອະນຸມັດແລ້ວ",
  REJECTED: "ປະຕິເສດ",
};

export const TOPUP_STATUS_BADGE: Record<
  TopupRequestStatus,
  "default" | "secondary" | "destructive" | "outline"
> = {
  PENDING: "secondary",
  APPROVED: "default",
  REJECTED: "destructive",
};
